import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import Gallery from "@/pages/Gallery";
import CollectibleDetail from "@/pages/CollectibleDetail";
import AdminDashboard from "@/pages/AdminDashboard";
import CreatorStudio from "@/pages/CreatorStudio";
import CreatorsDirectory from "@/pages/CreatorsDirectory";
import CreatorProfile from "@/pages/CreatorProfile";
import Login from "@/pages/Login";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Gallery />} />
      <Route path="/collectible/:id" element={<CollectibleDetail />} />
      <Route path="/creators" element={<CreatorsDirectory />} />
      <Route path="/profile/:userId" element={<CreatorProfile />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/studio"
        element={
          <ProtectedRoute>
            <CreatorStudio />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#0A0A0A",
                border: "1px solid rgba(255,255,255,0.1)",
                color: "#fff",
                borderRadius: 0,
                fontFamily: '"IBM Plex Mono", monospace',
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
